import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-brand-navy" data-id="element-55" data-mp="c4fw0l6gszqt">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-56" data-mp="83m6xohadewc">
        <p className="inline-block rounded bg-brand-orange px-2 py-0.5 font-display text-[0.62rem] font-bold uppercase tracking-[0.14em] text-brand-navy" data-id="element-57" data-mp="m46okhbgt4o9">
          Una última oportunidad
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.78rem] leading-snug text-white/80" data-id="element-58" data-mp="vv1f3xvquqfi">
          Puedes seguir buscando ejercicios, evaluaciones, actividades y
          recursos en diferentes lugares cada vez que necesitas preparar una
          clase. O puedes comenzar a trabajar con una estructura organizada que
          reúne los principales contenidos de Matemática de 1.º año.
        </p>
        <h2 id="cierre" className="mt-1.5 font-display text-base font-extrabold leading-tight text-white sm:text-xl" data-id="element-59" data-mp="2c5pxlx9spg38">
          No necesitas preparar cada recurso desde cero.{' '}
          <span className="text-brand-yellow" data-id="element-60" data-mp="2m21bgrp1adzs">
            Necesitas una base clara que puedas utilizar y adaptar.
          </span>
        </h2>

        <Reveal className="mt-3 rounded-xl border-4 border-dashed border-brand-yellow bg-white p-3 text-brand-navy" data-id="element-61" data-mp="2qzkrnx5al0ud">
          <p className="font-display text-[0.8rem] font-black uppercase leading-tight text-brand-blue sm:text-sm" data-id="element-62" data-mp="302c4o1dtg4o4">
            {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 font-display text-lg font-black uppercase tracking-wide" data-id="element-63" data-mp="34u3vmd0vwces">
            6 Tomos + 5 Bonos
          </p>
          <p className="text-[0.75rem] text-slate-700" data-id="element-64" data-mp="3eri3ho8qrsvh">
            Valor de los bonos:{' '}
            <span className="text-red-600 line-through" data-id="element-65" data-mp="3it39qqqrt8wp">{BONUS_VALUE}</span>
          </p>
          <p className="mt-1 font-display text-5xl font-black leading-none tracking-tight text-brand-blue sm:text-6xl" data-id="element-66" data-mp="3iqqsygwr14l8">
            <span className="font-hand text-4xl font-bold text-brand-navy sm:text-5xl" data-id="element-67" data-mp="1epij3n2xvvhp">
              Hoy:
            </span>{' '}
            {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-68" data-mp="1sirnf9c15qtd">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-medium text-slate-700" data-id="element-69" data-mp="22eky0n66va8i">
            <span className="flex items-center gap-1" data-id="element-70" data-mp="1xeousq5bfmu0">
              <ZapIcon size={12} className="text-brand-orange" data-id="element-71" data-mp="2bfj0v24w5bpi" />
              Acceso Inmediato
            </span>
            <span className="text-slate-400" data-id="element-72" data-mp="27debiflh718o">•</span>
            <span data-id="element-73" data-mp="27epdc9vd1yx5">Entrega Digital</span>
            <span className="text-slate-400" data-id="element-74" data-mp="h18ceus7kjk9">•</span>
            <span className="flex items-center gap-1" data-id="element-75" data-mp="h206u2a2kb8y">
              <ShieldCheckIcon size={12} className="text-brand-blue" data-id="element-76" data-mp="d0enby314yps" />
              Garantía de 7 Días
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}